import { TableConfig } from "../../../../../common/tables/config/TableConfig";
import { CostMetadataTableRow } from "../../../../../../../common/tables/cost-metadata/CostMetadataTableRow";
import { SortOrder } from "../../../../../../../common/query-filters";
import { CellType } from "../../../../../common/tables/config/CellType";

/**
 * Read-only CostMetadata table config for the variant side sheet, with a
 * leading "Assigned" checkbox column to toggle variant assignment.
 */
export const DefaultVariantCostMetadataSideSheetConfig: TableConfig<CostMetadataTableRow> = {
    columns: [
        {
            columnName: "hasAllVariantsCovered",
            displayName: "Assigned",
            cellType: CellType.checkbox,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "90px",
            textAlign: "center",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "id",
            displayName: "Cost Metadata ID",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "220px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "modifier",
            displayName: "Name",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "140px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "startDate",
            displayName: "Start Date",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "unitCost",
            displayName: "Unit Cost ($)",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "130px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "juniperServiceFee",
            displayName: "Service Fee ($)",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "fulfillmentFee",
            displayName: "Fulfillment Fee ($)",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "165px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "processingFeePercent",
            displayName: "Processing Fee (%)",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "165px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "shippingSubsidy",
            displayName: "Shipping Subsidy ($)",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "170px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "variantSkus",
            displayName: "Variants",
            cellType: CellType.readOnlyText,
            hidden: true,
            filtered: false,
            sticky: false,
            width: "200px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "costPayoutModifierName",
            displayName: "Cost Payout Modifier",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "180px",
            sortable: false,
            filterable: false,
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.DESCENDING,
        sortColumn: "startDate",
        pageSize: 200,
    },
};
